import React from 'react';
import { FsHeading } from '@finalsite/wc-react';

export const SubsectionField = ({ field }) => {
  return <FsHeading type={'title4'}>{field.rendered_prompt}</FsHeading>;
}
